import { useState } from 'react';
import { fmtCents } from '../format.js';
import RecurringScreen from './Recurring.jsx';
import DebtsScreen from './Debts.jsx';
import SinkingFundsScreen from './SinkingFunds.jsx';
import GoalsScreen from './Goals.jsx';
import BudgetsScreen from './Budgets.jsx';

const SECTIONS = [
  { id: 'recurring',     label: 'Recurring',      desc: 'Bills, paychecks, savings rules' },
  { id: 'debts',         label: 'Debts',          desc: 'Balances, APRs, promo dates' },
  { id: 'sinking_funds', label: 'Sinking Funds',  desc: 'Annual buckets accruing monthly' },
  { id: 'goals',         label: 'Goals',          desc: 'Savings goals + progress' },
  { id: 'budgets',       label: 'Budgets',        desc: 'Monthly category targets' },
];

export default function Manage(props) {
  const [section, setSection] = useState(null);

  if (section === 'recurring')     return <RecurringScreen     {...props} onBack={() => setSection(null)} />;
  if (section === 'debts')         return <DebtsScreen         {...props} onBack={() => setSection(null)} />;
  if (section === 'sinking_funds') return <SinkingFundsScreen  {...props} onBack={() => setSection(null)} />;
  if (section === 'goals')         return <GoalsScreen         {...props} onBack={() => setSection(null)} />;
  if (section === 'budgets')       return <BudgetsScreen       {...props} onBack={() => setSection(null)} />;

  const { state } = props;

  // Quick stats per section
  const stats = {
    recurring: `${state.recurring.filter(r => r.active).length} active`,
    debts: `${fmtCents(state.debts.filter(d => !d.archived).reduce((s,d) => s + (d.live_balance_cents ?? d.current_cents), 0))} outstanding`,
    sinking_funds: `${state.sinking_funds.filter(s => !s.archived).length} buckets`,
    goals: `${state.goals.filter(g => !g.archived).length} goals`,
    budgets: `${state.budgets.length} category targets`,
  };

  return (
    <div className="screen">
      <h1>Manage</h1>
      <div className="muted" style={{ marginBottom: 20 }}>Edit any part of your finances. Changes save instantly.</div>
      <div className="stack" style={{ gap: 8 }}>
        {SECTIONS.map(s => (
          <button key={s.id} className="card" onClick={() => setSection(s.id)}
                  style={{
                    textAlign: 'left', display: 'block', cursor: 'pointer',
                    padding: 16, marginBottom: 0, borderColor: 'var(--border2)',
                  }}>
            <div className="row between" style={{ marginBottom: 4 }}>
              <strong>{s.label}</strong>
              <span style={{ color: 'var(--text3)' }}>›</span>
            </div>
            <div className="muted tiny" style={{ marginBottom: 4 }}>{s.desc}</div>
            <div className="tiny" style={{ color: 'var(--teal)' }}>{stats[s.id]}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
